import React, { useState } from "react";
import { connect } from "react-redux";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { Product, SelectedProduct } from "~/common/Store/models/ProductListing";
import AddToCartButton from "../productListing/ProductBox/AddToCart";
import PlatinumPlusExclusive from "../productListing/ProductBox/PlatinumPlusExclusive";
import isNonExclusiveForPlatinumPlusProduct from "~/productListing/ProductBox/isNonExclusivePlatinumPlusProduct";
import { RootState, UserState } from "~/common/Store/models/RootReadonly";

interface Props {
  product: Product;
  index: number;
  isTopProductsMember: boolean;
  user: UserState;
}
const ExpandedProductCarouselMember = ({
  product,
  index,
  isTopProductsMember,
  user,
}: Props) => {
  const plusRibbon = (
    <a href="/plus/" className="ribbon ribbon--mini ribbon--plus">
      <span className="ribbon__text">plus</span>
    </a>
  );
  const [selectedProduct, setSelectedProduct] = useState<SelectedProduct>({
    ...product,
    activeSale: product.price.displaySalePrice,
    isOutlet: product.outletAttributes && product.outletAttributes.isOutlet,
  });

  return (
    <li className="ag-item" key={`top-product${index}`}>
      <div className="product-image">
        <a
          href={product.link}
          className="image companionItemClicked"
          title={product.description}
          data-testid="itemImageLink"
          data-label={product.feedIdentifier}
          data-action="click"
        >
          <img alt={product.description} src={product.primaryImagePath} />
        </a>
      </div>
      <a
        href={product.link}
        className="description companionItemClicked"
        title={product.description}
        data-testid="itemDescriptionLink"
        data-label={product.feedIdentifier}
        data-action="click"
      >
        {product.description}
      </a>

      {selectedProduct.price.price > 0 && (
        <div
          className="pricing"
          data-component="Pricing"
          style={{ textAlign: "center" }}
        >
          <PlatinumPlusExclusive
            user={user}
            customerExclusivity={product.customerExclusivity}
          />
          <p className="price">
            {` ${formatAsCurrency.formatIfUndefined(
              selectedProduct.price.price,
            )} `}
            {selectedProduct.unitOfMeasure && (
              <span className="each">
                {` / ${selectedProduct.unitOfMeasure}`}
              </span>
            )}
          </p>
        </div>
      )}
      {product.isWebstaurantPlusEligible &&
        (isTopProductsMember ? (
          plusRibbon
        ) : (
          <div className="ribbon-stack">{plusRibbon}</div>
        ))}
      {isNonExclusiveForPlatinumPlusProduct(
        product.customerExclusivity,
        user,
      ) && (
        <AddToCartButton
          {...{
            product,
            user,
            selectedProduct,
            setSelectedProduct,
            isCarouselProductBox: true,
          }}
        />
      )}
    </li>
  );
};

export const mapStateToProps = (state: RootState) => ({ user: state.user });

export default connect(mapStateToProps)(ExpandedProductCarouselMember);
